<div class="flex justify-between px-6 py-4 bg-white shadow shrink-0 z-10">
    <!-- <div class="gap-4">
      <input type="text" [(ngModel)]="searchTerm" (input)="applyFilters()" placeholder="Buscar por nome ou código..." class="border border-gray-300 rounded px-3 py-2 text-sm" />
    </div> -->
    <!-- <div class=" gap-4">
      <p-splitbutton label="Exportar" [model]="items" />
    </div> -->
</div>

<div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32 ">
    <div class="bg-white shadow rounded overflow-x-auto">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-100 sticky top-0 z-10">
          <tr>
            <th class="text-left px-6 py-3">Código</th>
            <th class="text-left px-6 py-3">Barras</th>
            <th class="text-left px-6 py-3">Produto</th>
            <th class="text-left px-6 py-3">Quantidade</th>
            <th class="text-left px-6 py-3">Preço</th>
            <th class="text-left px-6 py-3">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itens; let i = index" [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ item.productId }}</td>
            <td class="px-6 py-2 font-mono">{{ item.barCode }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ item.description }}</td>
            <td class="px-6 py-2 text-green-600 font-medium">{{ item.amount | number: '1.2-2' }}</td>
            <td class="px-6 py-2 text-green-600 font-medium">R$ {{ item.price | number: '1.2-2' }}</td>
            <td class="px-6 py-2 text-green-600 font-medium">R$ {{ item.total | number: '1.2-2' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>